export const MERGE_SOURCE_TOUR_ID = 9;
export const MERGE_TARGET_TOUR_ID = 77;
export const MERGE_DEPARTURE = "MIDDAY";

export function isMergeHotfixApplicable(tourId, departure) {
  return Number(tourId) === MERGE_SOURCE_TOUR_ID && departure === MERGE_DEPARTURE;
}

export function getGroupingTour(order) {
  return order?.OperationalTour || order?.Customer?.Tour;
}

export function resolveTargetTourId(customer, departure, { routes = [], customerList = [] } = {}) {
  const customerTourId = customer?.Tour?.id ?? customer?.tour_id ?? null;
  if (!isMergeHotfixApplicable(customerTourId, departure)) {
    return customerTourId;
  }

  const fromRoute = routes.find((route) => Number(route?.Tour?.id) === MERGE_TARGET_TOUR_ID);
  if (fromRoute?.Tour?.id != null) {
    return fromRoute.Tour.id;
  }

  const fromCustomer = customerList.find(
    (entry) => Number(entry?.Tour?.id) === MERGE_TARGET_TOUR_ID
  );
  if (fromCustomer?.Tour?.id != null) {
    return fromCustomer.Tour.id;
  }

  return MERGE_TARGET_TOUR_ID;
}

export function isTargetTourDepartureStarted(routes, targetTourId, departure) {
  if (targetTourId == null) {
    return false;
  }

  return (routes || []).some((route) => {
    if (Number(route?.Tour?.id) !== Number(targetTourId)) {
      return false;
    }
    const routeDeparture =
      route?.delivery_timing_config?.delivery_timing ||
      route?.pathway?.[0]?.Orders?.[0]?.departure;
    return routeDeparture === departure;
  });
}
